// extracted by mini-css-extract-plugin
module.exports = {"hide":"AutoEllipsisText_hide__um244","text":"AutoEllipsisText_text__KZyRX","moreLine":"AutoEllipsisText_moreLine__RT0we","tipText":"AutoEllipsisText_tipText__A2WMZ"};